// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import AccountMessages from "@insite/content-library/Widgets/MyAccount/AccountMessages";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@steiner/App/Components/Common/XngZone";
import * as React from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface MyAccountViewStyles {
    quickLinksGridItem?: GridItemProps;
    mainSectionGridItem?: GridItemProps;
    mainSectionGridContainer?: GridContainerProps;
    accountMessagesGridItem?: GridItemProps;
    dashboardWidgetsGridItem?: GridItemProps;
    // XNG-Change
    mainContainer?: InjectableCss;
    pageTitleGridItem?: InjectableCss;
    welcomeWidgetsGridItem?: InjectableCss;
    extraCardsGridItem?: InjectableCss;
}

export const myAccountViewStyles: MyAccountViewStyles = {
    quickLinksGridItem: { width: [12, 12, 12, 2, 2] },
    mainSectionGridItem: { width: [12, 12, 12, 10, 10] },
    accountMessagesGridItem: { width: 12 },
    dashboardWidgetsGridItem: { width: 12 },
};

const styles = myAccountViewStyles;

class MyAccountView extends React.PureComponent<Props> {
    render() {
        // XNG-Change: Structure Update
        return (
            <StyledWrapper {...styles.mainContainer}>
                <StyledWrapper {...styles.pageTitleGridItem}>
                    <XngZone contentId={this.props.id} zoneName="PageTitle" hint="Page Title" />
                </StyledWrapper>
                <StyledWrapper {...styles.quickLinksGridItem}>
                    <XngZone contentId={this.props.id} zoneName="NavigationList" hint="Links & Profile" />
                </StyledWrapper>
                <StyledWrapper {...styles.mainSectionGridItem}>
                    <StyledWrapper {...styles.welcomeWidgetsGridItem}>
                        <XngZone contentId={this.props.id} zoneName="WelcomeWidgets" hint="Welcome Widgets" />
                    </StyledWrapper>
                    <StyledWrapper {...styles.accountMessagesGridItem}>
                        <AccountMessages />
                    </StyledWrapper>
                    <StyledWrapper {...styles.dashboardWidgetsGridItem}>
                        <XngZone contentId={this.props.id} zoneName="DashboardWidgets" hint="Dashboard Widgets" />
                    </StyledWrapper>
                </StyledWrapper>
                <GridItem {...styles.extraCardsGridItem}>
                    <XngZone contentId={this.props.id} zoneName="ExtraCards" hint="Extra Cards" />
                </GridItem>
            </StyledWrapper>
        );
    }
}

const myAccountViewWidget: WidgetModule = {
    component: MyAccountView,
    definition: {
        allowedContexts: ["MyAccountPage"],
        group: "My Account",
    },
};

export default myAccountViewWidget;
